import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FormField, FormGrid, Page, SelectionList, Text, } from '@dixa/lib-shared-habla';
import { useCallback, useMemo } from 'react';
import { useFormContext } from 'react-hook-form';
import audioManager from 'app/utils/audioManager';
import { HookFormSelectionList } from 'components/hookForm';
import { NOTIFICATION_SOUND_OPTIONS, OFFER_NOTIFICATION_SOUND_OPTIONS, } from 'components/notifications/sagas/audio';
import { useBreakpointValue } from 'utils/mediaQuery';
export const ProfileFormSounds = () => {
    const isSmallScreen = useBreakpointValue({ base: true, md: false });
    const { control, getValues } = useFormContext();
    const handlePlaySound = useCallback((name) => {
        const values = getValues();
        audioManager.stop();
        audioManager.play(values[name], name, false);
    }, [getValues]);
    const offerSoundsFormFields = useMemo(() => Object.entries(offerSoundsAssets).map(([name, label]) => (_jsx(FormField, Object.assign({ span: isSmallScreen ? 6 : 3 }, { children: _jsx(HookFormSelectionList, Object.assign({ control: control, name: name, label: label, rules: {
                required: 'Please select a sound',
            }, componentProps: {
                placeholder: 'Select a sound',
                suffix: {
                    type: 'button',
                    button: {
                        icon: 'volume-up',
                        onClick: (e) => {
                            e.stopPropagation();
                            handlePlaySound(name);
                        },
                        'aria-label': `Play ${label}`,
                    },
                },
                getItemTitleByValue: (value) => {
                    var _a, _b;
                    return (_b = (_a = OFFER_NOTIFICATION_SOUND_OPTIONS.find((item) => item.value === value)) === null || _a === void 0 ? void 0 : _a.label) !== null && _b !== void 0 ? _b : value;
                },
            } }, { children: OFFER_NOTIFICATION_SOUND_OPTIONS.map(({ label, value }) => (_jsx(SelectionList.Item, Object.assign({ value: value }, { children: _jsx(Text.Paragraph, { children: label }) }), value))) })) }), name))), [control, handlePlaySound, isSmallScreen]);
    return (_jsx(Page.Section, Object.assign({ title: "Sound notifications" }, { children: _jsxs(FormGrid, { children: [offerSoundsFormFields, _jsx(FormField, Object.assign({ span: isSmallScreen ? 6 : 3 }, { children: _jsx(HookFormSelectionList, Object.assign({ control: control, name: "notification_sound", label: "Notification sound", rules: {
                            required: 'Please select a sound',
                        }, componentProps: {
                            placeholder: 'Select a sound',
                            suffix: {
                                type: 'button',
                                button: {
                                    icon: 'volume-up',
                                    onClick: (e) => {
                                        e.stopPropagation();
                                        handlePlaySound('notification_sound');
                                    },
                                    'aria-label': `Play notification sound`,
                                },
                            },
                            getItemTitleByValue: (value) => {
                                var _a, _b;
                                return (_b = (_a = NOTIFICATION_SOUND_OPTIONS.find((item) => item.value === value)) === null || _a === void 0 ? void 0 : _a.label) !== null && _b !== void 0 ? _b : value;
                            },
                        } }, { children: NOTIFICATION_SOUND_OPTIONS.map(({ label, value }) => (_jsx(SelectionList.Item, Object.assign({ value: value }, { children: _jsx(Text.Paragraph, { children: label }) }), value))) })) }))] }) })));
};
const offerSoundsAssets = {
    offer_notification_phone: 'Phone sound',
    offer_notification_chat: 'Chat sound',
    offer_notification_email: 'Email sound',
    offer_notification_messaging: 'Messaging sound',
};
